export const formatToFloat = (value: any, precision?: number): number => {
  if (typeof value === "number") {
    return value;
  } else if (typeof value === "string") {
    const stringValue = value.replace("$", "").replace(",", "");
    if (precision) {
      return parseFloat(parseFloat(stringValue).toFixed(precision));
    } else {
      return parseFloat(stringValue);
    }
  }
};
